<script>
	import IrelandMap from './components/IrelandMap.svelte';
	import IrelandCasesDeaths from './components/IrelandCasesDeaths.svelte';
	import EuropeMap from './components/EuropeMap.svelte';
	import DataSources from './components/DataSources.svelte';
	import InternationalCasesDeaths from './components/InternationalCasesDeaths.svelte';
	import * as d3 from 'd3';
	import {BASE_DATA_URL} from './constants';
	import {buildCacheParam, getLastDate} from './utils';
	import {onMount} from 'svelte';
	import Vaccinations from './components/Vaccinations.svelte';
	import { formatDate } from './utils';

	let internationalCasesData;

	$: dataUpdatedDateStr = formatDate(internationalCasesData && getLastDate(internationalCasesData, "location", "%Y-%m-%d"))

	onMount(async () => {
		internationalCasesData = await d3.csv(`${BASE_DATA_URL}/international-cases.csv?d=${buildCacheParam()}`);
	});
</script>

<main>
	<h1>COVID-19 in Ireland</h1>
	<Vaccinations/>
	<IrelandMap/>
	<IrelandCasesDeaths/>
	<EuropeMap/>
	<InternationalCasesDeaths casesData={internationalCasesData}/>
	<p class="last-updated--global">Data updated: {dataUpdatedDateStr}</p>
	<DataSources/>
</main>
